import React, { useContext } from 'react'
import { RiskProductsContext } from '../../context'
import { ConfirmationDialog } from '@components/Dialog'
import { Button } from '@components/Button'

export const Destroy = () => {
  const { state, actions } = useContext(RiskProductsContext)
  const { riskProduct, loading } = state
  const { confirmDelete, back } = actions

  const trackingText = 'Risk Product: Delete confirm'
  return (
    <ConfirmationDialog
      heading='Are you sure you want to delete this Risk Product?'
      subheading={riskProduct.name}
      primaryButton={() =>
        <Button disabled={loading} primary trackAs={trackingText} onClick={confirmDelete}>
          {loading ? 'Deleting risk product...' : "YES I'M SURE"}
        </Button>}
      secondaryButton={() => <Button disabled={loading} secondary onClick={back}>CANCEL</Button>}
    />
  )
}
